import React, { useEffect, useState } from 'react';
import { Header } from './components/Header';
import { UserProfileSelector } from './components/UserProfileSelector';
import { WeatherSelector } from './components/WeatherSelector';
import { OutfitRecommendation } from './components/OutfitRecommendation';
import { WardrobeSection } from './components/WardrobeSection';
import { TrendsSection } from './components/TrendsSection';
import { MarketplaceSection } from './components/MarketplaceSection';
export function App() {
  const [selectedCity, setSelectedCity] = useState('New York');
  const [weatherData, setWeatherData] = useState({
    temperature: 72,
    condition: 'Sunny',
    season: 'Summer',
    cityName: 'New York'
  });
  const [userProfile, setUserProfile] = useState({
    gender: '',
    style: '',
    bodyType: '',
    ageRange: ''
  });
  // Mock function to update weather data based on city selection
  const updateWeather = city => {
    const weatherMock = {
      // North America
      'New York': {
        temperature: 72,
        condition: 'Sunny',
        season: 'Summer',
        cityName: 'New York'
      },
      'Los Angeles': {
        temperature: 85,
        condition: 'Sunny',
        season: 'Summer',
        cityName: 'Los Angeles'
      },
      Chicago: {
        temperature: 68,
        condition: 'Partly Cloudy',
        season: 'Spring',
        cityName: 'Chicago'
      },
      Miami: {
        temperature: 88,
        condition: 'Clear',
        season: 'Summer',
        cityName: 'Miami'
      },
      // Canada
      Toronto: {
        temperature: 65,
        condition: 'Partly Cloudy',
        season: 'Spring',
        cityName: 'Toronto'
      },
      Vancouver: {
        temperature: 60,
        condition: 'Rainy',
        season: 'Spring',
        cityName: 'Vancouver'
      },
      Montreal: {
        temperature: 58,
        condition: 'Cloudy',
        season: 'Spring',
        cityName: 'Montreal'
      },
      Calgary: {
        temperature: 45,
        condition: 'Snowy',
        season: 'Winter',
        cityName: 'Calgary'
      },
      Ottawa: {
        temperature: 52,
        condition: 'Rainy',
        season: 'Spring',
        cityName: 'Ottawa'
      },
      // Europe
      London: {
        temperature: 62,
        condition: 'Rainy',
        season: 'Spring',
        cityName: 'London'
      },
      Paris: {
        temperature: 70,
        condition: 'Partly Cloudy',
        season: 'Spring',
        cityName: 'Paris'
      },
      Berlin: {
        temperature: 66,
        condition: 'Cloudy',
        season: 'Spring',
        cityName: 'Berlin'
      },
      Rome: {
        temperature: 78,
        condition: 'Sunny',
        season: 'Summer',
        cityName: 'Rome'
      },
      Barcelona: {
        temperature: 76,
        condition: 'Clear',
        season: 'Summer',
        cityName: 'Barcelona'
      },
      // Asia
      Tokyo: {
        temperature: 80,
        condition: 'Clear',
        season: 'Summer',
        cityName: 'Tokyo'
      },
      Seoul: {
        temperature: 75,
        condition: 'Partly Cloudy',
        season: 'Summer',
        cityName: 'Seoul'
      },
      Singapore: {
        temperature: 90,
        condition: 'Clear',
        season: 'Summer',
        cityName: 'Singapore'
      },
      Dubai: {
        temperature: 102,
        condition: 'Sunny',
        season: 'Summer',
        cityName: 'Dubai'
      },
      'Hong Kong': {
        temperature: 85,
        condition: 'Rainy',
        season: 'Summer',
        cityName: 'Hong Kong'
      },
      // Oceania
      Sydney: {
        temperature: 65,
        condition: 'Cloudy',
        season: 'Fall',
        cityName: 'Sydney'
      },
      Melbourne: {
        temperature: 60,
        condition: 'Rainy',
        season: 'Fall',
        cityName: 'Melbourne'
      },
      Auckland: {
        temperature: 63,
        condition: 'Partly Cloudy',
        season: 'Fall',
        cityName: 'Auckland'
      }
    };
    setWeatherData(weatherMock[city] || weatherMock['New York']);
  };
  useEffect(() => {
    updateWeather(selectedCity);
  }, [selectedCity]);
  return <div className="min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="container mx-auto px-4 py-6" data-id="element-2">
        {/* Top section with profile and weather side by side */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6" data-id="element-3">
          <div className="md:col-span-1" data-id="element-4">
            <UserProfileSelector userProfile={userProfile} setUserProfile={setUserProfile} data-id="element-5" />
          </div>
          <div className="md:col-span-1" data-id="element-6">
            <WeatherSelector selectedCity={selectedCity} setSelectedCity={setSelectedCity} weatherData={weatherData} data-id="element-7" />
          </div>
        </div>
        {/* Outfit recommendations section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8" data-id="element-8">
          <div className="lg:col-span-2" data-id="element-9">
            <OutfitRecommendation weatherData={weatherData} userProfile={userProfile} data-id="element-10" />
          </div>
          <div className="lg:col-span-1" data-id="element-11">
            <WardrobeSection userProfile={userProfile} data-id="element-12" />
          </div>
        </div>
        {/* Trends section */}
        <div className="mb-8" data-id="element-13">
          <TrendsSection data-id="element-14" />
        </div>
        {/* Marketplace section */}
        <div className="mb-8" data-id="element-15">
          <MarketplaceSection data-id="element-16" />
        </div>
      </main>
    </div>;
}